
import clamp from '@/plugins/clamp';
export default {
  props: {
    tag: {
      type: String,
      default: 'p'
    },
    maxLines: {
      type: [Number, String],
      default: undefined
    },
    maxHeight: {
      type: [Number, String],
      default: undefined
    }
  },

  computed: {
    isTagH2Title () {
      return this.tag === 'h2';
    }
  },

  watch: {
    '$slots.default' () {
      this.clamp();
    }
  },

  updated () {
    if (!this.$el || this.$el.nodeType === Node.COMMENT_NODE) { return; }

    this.clamp();
  },

  mounted () {
    if (!this.$el || this.$el.nodeType === Node.COMMENT_NODE) { return; }

    this.clamp();
    const observer = new ResizeObserver(() => this.clamp());
    observer.observe(this.$el);
  },

  methods: {
    clamp () {
      clamp(this.$el, {
        clamp: Number(this.maxLines) || (this.maxHeight ?? 'auto')
      });
    }
  }
};
